/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VlsrPersonaEnum = 'VLSR' | 'VLSR_MTDR';

export const VlsrPersonaEnum = {

    VLSR: 'VLSR' as VlsrPersonaEnum,

    VLSR_MTDR: 'VLSR_MTDR' as VlsrPersonaEnum
};

